// extracted by mini-css-extract-plugin
export default {"patronNoticeForm":"patronNoticeForm---Cy3ci"};